import React from 'react';
import { GraphHead } from '../../../../components/common/GraphHeading';
import TController from './TController';
import ParetoChart from './ParetoChart';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
interface IProps {
  apiData: any;
  year: number;
  title1: any;
  // vendors: any;
  // vendorName: any;
  // setRender: any;
  month: any;
}
const Type = ({
  apiData,
  year,
  title1,
  // vendors,
  // vendorName,
  // setRender,
  month,
}: IProps) => {
  return (
    <>
      <TController apiData={apiData} year={year} month={month} />
      <GraphHead
        style={{
          width: '90vw',
          margin: '5rem auto', // Center the component
          textAlign: 'center',
        }}
      >
        <p>{title1}</p>
        <ParetoChart apiData={apiData} />
      </GraphHead>
    </>
  );
};

export default Type;
